<script setup>
import DialogModal from "../Components/DialogModal.vue";
import { useForm } from "@inertiajs/vue3";
import { onMounted, onUnmounted, reactive } from "vue";
import eventBus from "@/Helpers/eventBus";
import Button from "../Components/Button.vue";
import FormInput from "@/Components/FormInput.vue";

const props = defineProps({
    myvehicle: Object,
});

const modal = reactive({
    show: false,
    type: "create",
});
const form = useForm({
    myvehicle_id: props.data?.id || null,
    ccs_id: props.data?.ccs_id || null,
    id: props.data?.id || null,
    v_type: props.v_type || null,
    year: props.year || null,
    make: props.make || null,
    model: props.model || null,
    cylinders: props.cylinders || null,
    cc: props.cc || null,
    weight: props.weight || null,
    reg_no: props.reg_no || null,
});

function showModal(type = "create", item = null, ccs = null) {
    modal.show = true;
    modal.type = type;

    if (ccs) {
        if (item === null) {
            // from track leaderboard never exists
            item = {};
        }
        item.ccs_id = ccs.id;
        item.myvehicle_id = ccs.myvehicle_id;
    }

    if (item) {
        Object.assign(form, item);
    }
}

function closeModal() {
    //console.log(arguments);
    modal.show = false;
    form.reset();
    form.clearErrors();
}

onMounted(() => {
    // console.log("onMounted CompetitorFormModal");
    eventBus.$on("showMyVehicleModal", (argsObj) => {
        showModal(argsObj.type, argsObj.vehicle, argsObj.ccs);
    });
});

onUnmounted(() => {
    // console.log("onUnmounted CompetitorFormModal");
    eventBus.$off("showMyVehicleModal");
});

function createDocument() {
    form.post(route("my-vehicles.createOrUpdate"), {
        preserveScroll: true,
        onSuccess: () => closeModal(),
    });
}
</script>

<template>
    <DialogModal
        :show="modal.show"
        @close="closeModal()"
    >
        <template #title>
            {{ modal.type === "create" ? "Create new Vehicle" : "" }}
            {{ modal.type === "update" ? "Update Vehicle" : "" }}
            {{ modal.type === "leaderboard" ? "Link your vehicle to this ride" : "" }}
        </template>

        <template #content>
            <form
                class="space-y-4"
                @submit.prevent="createDocument()"
            >
                <div
                    v-if="modal.type === 'leaderboard'"
                    class="col-span-6 sm:col-span-4"
                >
                    <FormInput
                        v-model="form.myvehicle_id"
                        label="Select from My Vehicles"
                        type="select"
                        :options="$page.props.myvehicles"
                        empty-option="--> Create new vehicle"
                        :empty-selectable="true"
                    ></FormInput>
                </div>
                <template v-if="modal.type !== 'leaderboard' || form.myvehicle_id === '--> Create new vehicle'">
                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.v_type"
                            label="Type*"
                            type="select"
                            :options="$page.props.app.vehicle_types"
                            :error="form.errors.v_type"
                        ></FormInput>
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.year"
                            label="Year"
                            type="number"
                            :error="form.errors.year"
                        ></FormInput>
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.make"
                            label="Make*"
                            type="text"
                            :error="form.errors.make"
                        ></FormInput>
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.model"
                            label="Model*"
                            type="text"
                            :error="form.errors.model"
                        ></FormInput>
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.cylinders"
                            label="Cylinders"
                            type="number"
                            :error="form.errors.cylinders"
                        ></FormInput>
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.cc"
                            label="Engine displacement (cc)"
                            type="number"
                            :error="form.errors.cc"
                        ></FormInput>
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.weight"
                            label="Weight (kg)"
                            type="number"
                            :error="form.errors.weight"
                        ></FormInput>
                    </div>

                    <div class="col-span-6 sm:col-span-4">
                        <FormInput
                            v-model="form.reg_no"
                            label="Registration number (used to autofill event reg. form)"
                            type="text"
                            :error="form.errors.reg_no"
                        ></FormInput>
                    </div>
                </template>
            </form>
        </template>

        <template #footer>
            <Button
                color="white"
                @click="closeModal()"
            >
                Cancel
            </Button>

            <Button
                class="ml-3"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
                @click="createDocument()"
            >
                <span v-if="modal.type === 'create'"> Create Vehicle</span>
                <span v-if="modal.type === 'update'"> Update Vehicle</span>
                <span v-if="modal.type === 'leaderboard'">
                    <template v-if="form.myvehicle_id !== '--> Create new vehicle'"> Link My Vehicle</template>
                    <template v-else> Create and link vehicle</template>
                </span>
            </Button>
        </template>
    </DialogModal>
</template>
